import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  type: PropTypes.string.isRequired,
  address: PropTypes.object.isRequired,
};

const Address = ({type, address}) => {
  const comma = address.addressLine2 && address.addressLine2.length >= 1 ? ', ' : '';

  return (
    <div className="address-container">
      <h5 className="address-type">{type} Address</h5>
      <span className="address-delivery-line">
        {address.addressLine1}
        {comma}
        {address.addressLine2}
      </span>
      <br />
      <span className="address-last-line">
        {address.city}, {address.subdivision} {address.postalCode}
      </span>
      <br />
    </div>
  );
};

Address.propTypes = propTypes;

export default Address;
